import React from 'react';
import { TimeInterval } from '../../types/types';
import useI18n from '../../hooks/useI18n';
import {
  adminPeriodSegmentActiveClass,
  adminPeriodSegmentInactiveClass,
  adminPeriodTrackClass,
} from '@/config/adminTheme';

interface ModernPeriodSelectorProps {
  selectedPeriod: TimeInterval;
  onPeriodChange: (period: TimeInterval) => void;
}

const ModernPeriodSelector: React.FC<ModernPeriodSelectorProps> = ({
  selectedPeriod,
  onPeriodChange,
}) => {
  const { t } = useI18n();
  const periods: TimeInterval[] = ['day', 'week', 'month', 'year'];

  const periodShort: Record<TimeInterval, string> = {
    day: 'D',
    week: 'W',
    month: 'M',
    year: 'Y',
  };

  return (
    <div className={adminPeriodTrackClass} role="group" aria-label="Period">
      {periods.map((period) => (
        <button
          key={period}
          type="button"
          onClick={() => onPeriodChange(period)}
          className={
            selectedPeriod === period
              ? adminPeriodSegmentActiveClass
              : adminPeriodSegmentInactiveClass
          }
        >
          <span className="hidden sm:inline">
            {t(`analytics.dates.${period}`)}
          </span>
          <span className="sm:hidden font-semibold">{periodShort[period]}</span>
        </button>
      ))}
    </div>
  );
};

export default ModernPeriodSelector;
